import View from './View';
import icons from 'url:../../img/icons.svg'; //Parcel 2

class AddRecipeView extends View {
  _parentElement = document.querySelector('.upload');
  _message = 'Recipe was successfully uploaded :)';

  _window = document.querySelector('.add-recipe-window');
  _overlay = document.querySelector('.overlay');
  _btnOpen = document.querySelector('.nav__btn--add-recipe');
  _btnClose = document.querySelector('.btn--close-modal');

  constructor() {
    super();
    this._addHandlerShowWindow();
    this._addHandlerHideWindow();
    this._addHandlerHideWindowOnEsc();
  }

  toggleWindow() {
    this._overlay.classList.toggle('hidden');
    this._window.classList.toggle('hidden');
  }

  _addHandlerShowWindow() {
    this._btnOpen.addEventListener('click', this.toggleWindow.bind(this));
  }

  _addHandlerHideWindow() {
    this._btnClose.addEventListener('click', this.toggleWindow.bind(this));
    this._overlay.addEventListener('click', this.toggleWindow.bind(this));
  }

  _hideWindow() {
    this._overlay.classList.add('hidden');
    this._window.classList.add('hidden');
  }

  _addHandlerHideWindowOnEsc() {
    const hideWindow = this._hideWindow.bind(this);
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') {
        hideWindow();
      }
    });
  }

  _formatedInputData() {
    const dataArray = [...new FormData(this._parentElement)];

    let recipeArray = [];
    const ingArr = [];

    for (let i = 6; i < dataArray.length; i++) {
      let value = [...dataArray[i]];
      ingArr.push(value[1]);
    }

    for (let i = 0; i < 6; i++) {
      recipeArray.push(dataArray[i]);
    }

    for (let i = 1; i < (dataArray.length - 5) / 3; i++) {
      const setOfIng = ingArr.splice(0, 3);
      recipeArray.push([`ingredient-${i}`, setOfIng.toString()]);
    }

    for (const [i, el] of recipeArray.entries()) {
      if (el[1] === ',,') {
        el[1] = '';
      }
    }

    //converting array data to a data object
    const data = Object.fromEntries(recipeArray);

    return data;
  }

  addHandlerUpload(handler) {
    const formatedInputData = this._formatedInputData.bind(this);
    this._parentElement.addEventListener('submit', function (e) {
      e.preventDefault();
      handler(formatedInputData());
    });
  }

  _generateMarkup() {}
}

export default new AddRecipeView();
